import { render, staticRenderFns } from "./advertising.vue?vue&type=template&id=445f9b53&scoped=true&"
import script from "./advertising.vue?vue&type=script&lang=js&"
export * from "./advertising.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445f9b53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445f9b53')) {
      api.createRecord('445f9b53', component.options)
    } else {
      api.reload('445f9b53', component.options)
    }
    module.hot.accept("./advertising.vue?vue&type=template&id=445f9b53&scoped=true&", function () {
      api.rerender('445f9b53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaul/components/advertising.vue"
export default component.exports